import { CheckIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface CheckboxProps {
	readonly disabled?: boolean;
	readonly className?: string;
	readonly name?: string;
	readonly checked?: boolean;
	readonly onCheckedChange?: (checked: boolean) => void;
}

function Checkbox(props: CheckboxProps) {
	const className = cn(
		"peer border-input dark:bg-input/30 mr-2",
		"data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary",
		"focus-visible:border-ring focus-visible:ring-ring/50",
		"aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
		"size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px]",
		"disabled:cursor-not-allowed disabled:opacity-50",
		props.className,
	);
	const hiddenInputStyle: React.CSSProperties = { position: "absolute", pointerEvents: "none", opacity: 0, margin: "0px", transform: "translateX(-100%)", width: "16px", height: "16px" };

	const onClick = () => {
		if (props.disabled) {
			return;
		}
		props.onCheckedChange?.(!props.checked);
	};
	const onKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
		if (props.disabled) {
			return;
		}
		if (event.key === " " || event.key === "Enter") {
			event.preventDefault();
			props.onCheckedChange?.(!props.checked);
		}
	};


	return <>
		<input aria-hidden="true" tabIndex={-1} type="checkbox" value={props.checked ? "true" : "false"} name={props.name} style={hiddenInputStyle} onChange={() => onClick()} />
		<button type="button" role="checkbox" aria-checked={props.checked ? "true" : "false"} data-state={props.checked ? "checked" : "unchecked"} className={className} onClick={onClick} onKeyDown={onKeyDown} >
			{props.checked && (
				<CheckIcon className="size-3.5" />
			)}
		</button>
	</>;
}

export { Checkbox };
